import { RouteConfig } from 'vue-router';

import SetPassword from '@/views/SetPassword.vue';

export const setPasswordRoute: RouteConfig = {
  path: '/set/:token',
  name: 'set',
  component: SetPassword
};
